// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetFriendsFriendsGetQueryResponse } from "../models/undefinedController/GetFriendsFriendsGet.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";
import type { QueryKey, QueryClient, UseQueryOptions, UseQueryReturnType } from "@tanstack/vue-query";
import { getFriendsFriendsGet } from "../client/getFriendsFriendsGet.ts";
import { queryOptions, useQuery } from "@tanstack/vue-query";
import { toValue } from "vue";

export const getFriendsFriendsGetQueryKey = () => [{ url: '/friends' }] as const

export type GetFriendsFriendsGetQueryKey = ReturnType<typeof getFriendsFriendsGetQueryKey>

export function getFriendsFriendsGetQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getFriendsFriendsGetQueryKey()
        return queryOptions<GetFriendsFriendsGetQueryResponse, ResponseErrorConfig<Error>, GetFriendsFriendsGetQueryResponse, typeof queryKey>({
        
        queryKey,
        queryFn: async ({ signal }) => {
            return getFriendsFriendsGet({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get Friends
 * {@link /friends}
 */
export function useGetFriendsFriendsGet<TData = GetFriendsFriendsGetQueryResponse, TQueryData = GetFriendsFriendsGetQueryResponse, TQueryKey extends QueryKey = GetFriendsFriendsGetQueryKey>(options: 
{
  query?: Partial<UseQueryOptions<GetFriendsFriendsGetQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = (resolvedOptions && 'queryKey' in resolvedOptions ? toValue(resolvedOptions.queryKey) : undefined) ?? getFriendsFriendsGetQueryKey()

         const query = useQuery({
          ...getFriendsFriendsGetQueryOptions(config),
          ...resolvedOptions,
          queryKey
         } as unknown as UseQueryOptions<GetFriendsFriendsGetQueryResponse, ResponseErrorConfig<Error>, TData, GetFriendsFriendsGetQueryResponse, TQueryKey>, toValue(queryClient)) as UseQueryReturnType<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}